<template>
  <div class="spinner">
  </div>
</template>

<style>
  .spinner {
    width:100%;
    height:100%;
    opacity: 1;
    z-index:10000;
    display:block;
    position:fixed;
    top:0;
    left:0;
    background-color: rgb(241, 241, 241);
    background-image: url('../assets/Disk-1s-200px.gif');
    background-repeat: no-repeat;
    background-position: 50% 50%;
  }
</style>